import { Button, HStack, Stack, Text } from '@chakra-ui/react'
import { useCallback } from 'react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { trackEvent } from '@/client/services/analytics'
import mutateAndRefreshPage from '@/client/services/trpcMutations'
import { useTRPCClient } from '@/client/trpc'

import { useToaster } from '@/components/Toast/useToaster'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function SeriesReservationCancelModal({
  seriesId,
  isOpen,
  onClose,
}: {
  seriesId: number
  isOpen: boolean
  onClose: () => void
}) {
  const toast = useToaster()
  const trpcClient = useTRPCClient()
  const [handleCancel, isSubmitting] = useAPIWrapper(
    async () => {
      await mutateAndRefreshPage(trpcClient.series.cancelReservation.mutate({ seriesId }))
      toast({
        title: 'Your reservation has been cancelled',
        status: 'success',
      })
      trackEvent({
        category: 'SAT Bootcamp - Registration',
        action: 'cancelled',
      })
    },
    [seriesId, toast],
    'Cancel Series Reservation'
  )

  const onClick = useCallback(async () => {
    await handleCancel()
    onClose()
  }, [handleCancel, onClose])

  return (
    <ModalV3
      size="md"
      open={isOpen}
      onClose={onClose}
      title="Cancel your Reservation"
      body={() => (
        <Stack direction="column" spacing={3}>
          <Text mb={2}>
            Are you sure you&apos;d like to cancel your reservation in this bootcamp?
          </Text>
        </Stack>
      )}
      rightFooterContent={() => (
        <HStack>
          <Button variant="outline" onClick={onClose}>
            No
          </Button>
          <Button variant="danger" onClick={onClick} isLoading={isSubmitting}>
            Cancel Reservation
          </Button>
        </HStack>
      )}
    />
  )
}
